import type { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-label="groq logo"
    role="img"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 250 250"
    {...props}
  >
    <g clipPath="url(#a)" transform="translate(50,50)">
      <path
        xmlns="http://www.w3.org/2000/svg"
        fill="#f43e01"
        d="M129.22,63.21c-.42-16.82-7.27-32.55-19.29-44.31C97.91,7.16,82.05.67,65.27.64h-.54C29.67.64,1,29.06.7,64.26c-.15,17.14,6.36,33.33,18.35,45.57,11.99,12.25,28,19.07,45.14,19.22h19.53v-34.01h-18.55c-8.04.11-15.64-2.96-21.39-8.59-5.75-5.63-8.97-13.18-9.06-21.26-.18-16.65,13.15-30.35,29.73-30.55h.8c16.55,0,30.09,13.55,30.19,30.17v59.37c0,16.43-13.37,29.96-29.82,30.17-7.88-.06-15.28-3.19-20.84-8.82l-4.32-4.36-.02.02-17.35,30.65c11.58,10.57,26.42,16.41,42.16,16.53h.87c16.88-.24,32.71-6.99,44.58-19.02,11.86-12.02,18.45-27.97,18.54-44.94v-61.19h-.02Z"
      />
    </g>
  </svg>
);
export default SvgComponent;
